import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-02a4140c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-wrap pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Bibliothèque de Vidéos"),
    /*#__PURE__*/_createElementVNode("p", { class: "section-subtitle" }, "Découvrez nos ressources vidéo éducatives")
  ])
], -1))
const _hoisted_4 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "loading-text" }, "Chargement des vidéos en cours...", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-dots" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"empty-icon\" data-v-02a4140c><i class=\"flaticon-video\" data-v-02a4140c></i></div><h3 class=\"empty-title\" data-v-02a4140c>Aucune vidéo disponible pour le moment</h3><p class=\"empty-description\" data-v-02a4140c> Nous travaillons actuellement sur l&#39;ajout de contenu vidéo éducatif. Revenez bientôt pour découvrir nos nouvelles ressources pédagogiques ! </p><div class=\"coming-soon-badge\" data-v-02a4140c><span data-v-02a4140c> Contenu en préparation</span></div>", 4)
const _hoisted_14 = [
  _hoisted_10
]
const _hoisted_15 = {
  key: 2,
  class: "row"
}
const _hoisted_16 = { class: "video-card" }
const _hoisted_17 = { class: "video-thumbnail" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "play-button" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" })
], -1))
const _hoisted_20 = { class: "duration-badge" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-clock" }, null, -1))
const _hoisted_22 = { class: "video-info" }
const _hoisted_23 = { class: "video-title" }
const _hoisted_24 = { class: "video-description" }
const _hoisted_25 = { class: "video-meta" }
const _hoisted_26 = { class: "views" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye" }, null, -1))
const _hoisted_28 = {
  key: 3,
  class: "mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_8))
        : (_ctx.videos.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_14))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (video, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-xl-4 col-lg-6 col-md-6 mb-4",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("img", {
                        src: video.thumbnail,
                        alt: "Video thumbnail"
                      }, null, 8, _hoisted_18),
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createTextVNode(" " + _toDisplayString(video.duree), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("h4", _hoisted_23, _toDisplayString(video.titre), 1),
                      _createElementVNode("p", _hoisted_24, _toDisplayString(video.description), 1),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("span", _hoisted_26, [
                          _hoisted_27,
                          _createTextVNode(" " + _toDisplayString(video.vues) + " vues ", 1)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])),
      (_ctx.videos.length > 0 && _ctx.totalPages > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createVNode(_component_PaginationComponent, {
              page: _ctx.page,
              totalPages: _ctx.totalPages,
              totalElements: _ctx.totalElements,
              limit: _ctx.limit,
              onPaginate: _ctx.handlePaginate
            }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}